// Widget Scripts
import cardWidget from './js/widgets/cardWidget.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWidgetMap from './js/widgets/cardWidgetMap.js';
import cardWidgetAds from './js/widgets/cardWidgetAds.js';
import cardWidgetEvent from './js/widgets/cardWidgetEvent.js';
import fairgroundsFeatureImage from './js/widgets/fairgroundsFeatureImage.js';
import fairgroundsCard from './js/widgets/fairgroundsCard.js';
import fairgroundsSeoText from './js/widgets/fairgroundsSeoText.js';
import fairgroundsSeo from './js/widgets/fairgroundsSeo.js';
import fairgroundsHeaderTickets from './js/widgets/fairgroundsHeaderTickets.js';
import fairgroundsRedTickets from './js/widgets/fairgroundsRedTickets.js';
import fairgroundsEvent from './js/widgets/fairgroundsEvent.js';
// import fairgroundsSponsors from './js/widgets/fairgroundsSponsors.js';
//import cardWidgetFeaturedEvents from './js/widgets/cardWidgetFeaturedEvents';
// import sponsorWidgetContainer from './js/widgets/cssSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';
import './js/cartpopup.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    cardWidget();
    swiperWidget();
    multiScheduleFeature();
    cardWidgetMap();
    cardWidgetAds();
    cardWidgetEvent();
    // fairgroundsEvent();
    // cardWidgetFeaturedEvents();

  });
}

if (window.location.pathname === '/' || $('body').hasClass('fairground-subpage')) {
  $(document).ready(function () {	
    fairgroundsFeatureImage();
    fairgroundsCard();
    fairgroundsSeoText();
    fairgroundsSeo();
    fairgroundsRedTickets();
    fairgroundsEvent();
  });
}
$(document).ready(function () {  		
   fairgroundsHeaderTickets();
   // fairgroundsSponsors();
  // sponsorWidgetContainer();
});